import { useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./ScholarshipFormModal.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

interface ScholarshipFormModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ScholarshipFormModal = ({ isOpen, onClose }: ScholarshipFormModalProps) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const getTypeformUrl = () => {
    const baseUrl = "https://fnmvyrypung.typeform.com/to/ZtH9bIUL";
    const url = new URL(baseUrl);

    // List of UTM and other tracking parameters to capture
    const trackingParams = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      "utm_group",
      "gclid",
      "fbclid",
      "msclkid",
      "keyword",
      "wbraid",
      "gbraid",
      "bd_vid",
    ];

    if (typeof window !== "undefined") {
      const currentUrlParams = new URLSearchParams(window.location.search);

      // Read session UTMs written by useTrackerJs — guaranteed to be set by the time
      // the user can click Apply Now (useEffect runs before any user interaction)
      let sessionUtmParams: Record<string, string> = {};
      try {
        const raw = sessionStorage.getItem("session_utm_params");
        if (raw !== null) {
          sessionUtmParams = JSON.parse(raw);
        }
      } catch (e) {
        // sessionStorage unavailable
      }

      trackingParams.forEach((param) => {
        // First priority: Current URL parameters
        if (currentUrlParams.has(param)) {
          url.searchParams.set(param, currentUrlParams.get(param) || "");
        }
        // Second priority: Session storage (current session only, no cross-session bleed)
        else if (sessionUtmParams[param]) {
          url.searchParams.set(param, sessionUtmParams[param]);
        }
      });
    }

    return url.toString();
  };

  if (!isOpen) return null;

  return (
    <>
      {createPortal(
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <div className={styles.overlay} onClick={onClose}>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              className={styles.closeButton}
            >
              ×
            </button>
            <iframe
              src={getTypeformUrl()}
              className={styles.iframe}
              title="Amber Scholarship Application"
            />
          </div>
        </div>,
        document.body,
      )}
    </>
  );
};

export default wrapperHOC(ScholarshipFormModal, {
  componentName: "ScholarshipFormModal",
  showForChina: true,
});
